<template>

  <page>
    <template v-slot:page-title>
      <h1 class="title">Playbooks</h1>
    </template>

    <template v-slot:page-buttons>
      <button
        class="button is-link"
        @click="showCreateForm = !showCreateForm"
      >
        <span class="icon"><i class="fas fa-plus"></i></span>
        <span>Playbook</span>
      </button>
    </template>

    <div v-if="playbookCms.loading && !playbookCms.playbooks.length" class="notification is-light">
      Loading playbooks...
    </div>

    <!-- Create playbook form -->
    <div v-if="showCreateForm" class="box" style="margin-bottom: 1.5rem;">
      <div class="field has-addons">
        <div class="control is-expanded">
          <input
            class="input"
            type="text"
            v-model="newPlaybookName"
            placeholder="Playbook name"
            @keyup.enter="handleCreatePlaybook"
          />
        </div>
        <div class="control">
          <button
            class="button is-success"
            @click="handleCreatePlaybook"
            :disabled="playbookCms.loading"
          >
            Create
          </button>
        </div>
        <div class="control">
          <button
            class="button"
            @click="showCreateForm = false"
          >
            Cancel
          </button>
        </div>
      </div>
      <p v-if="playbookCms.errors.name" class="help is-danger">{{ playbookCms.errors.name }}</p>
    </div>

    <playbook-card
      v-for="playbook in playbookCms.playbooks"
      :key="playbook.id"
      :playbook="playbook"
      :errors="playbookCms.errors"
      :loading="playbookCms.loading"
      @update-playbook="updatePlaybook"
      @delete-playbook="deletePlaybook"
      @create-bucket="createBucket"
      @update-bucket="updateBucket"
      @delete-bucket="deleteBucket"
      @create-play="createPlay"
      @update-play="updatePlay"
      @delete-play="deletePlay"
    />

    <div v-if="!playbookCms.loading && !playbookCms.playbooks.length && !showCreateForm" class="notification is-light">
      No playbooks yet. Click "+ Playbook" to create one.
    </div>
  </page>

</template>
<script>

  import Page from '~/components/Page.vue';
  import PlaybookCard from '~/components/playbook/PlaybookCard.vue';
  import PlaybookCmsContext from './mixins/PlaybookCmsContext.vue';

  export default {

    mixins: [PlaybookCmsContext],

    components: {
      Page,
      PlaybookCard,
    },

    data () {
      return {
        showCreateForm: false,
        newPlaybookName: '',
      };
    },

    async mounted () {
      await this.initializePlaybookCmsContext();
    },

    methods: {

      async handleCreatePlaybook () {
        if (!this.newPlaybookName.trim()) {
          return;
        }
        await this.createPlaybook({name: this.newPlaybookName.trim()});
        this.newPlaybookName = '';
        this.showCreateForm = false;
      },

    },
  };

</script>
